// @flow weak

import _ from 'lodash/fp';
import {GET} from '../helpers/request';

export const PROJECTS_REQUEST = '@sales/PROJECTS_REQUEST';
export const PROJECTS_SUCCESS = '@sales/PROJECTS_SUCCESS';
export const PROJECTS_FAILURE = '@sales/PROJECTS_FAILURE';

export const FILTER = '@sales/FILTER';

export const projectsRequest = () => ({
  type: PROJECTS_REQUEST,
});

export const projectsSuccess = projects => ({
  type: PROJECTS_SUCCESS,
  projects,
});

export const projectsError = error => ({
  type: PROJECTS_FAILURE,
  error,
});

export const filter = projectId => ({
  type: FILTER,
  projectId,
});

export const fetchProjects = () => async dispatch => {
  dispatch(projectsRequest());
  try {
    const projects = await GET({endpoint: '/dataexports/projects'}, dispatch);
    dispatch(projectsSuccess(_.sortBy('id', projects)));
  } catch (err) {
    dispatch(projectsError(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/salesView.js